import Vue from 'vue'

import Copyright from './Copyright.vue'

Vue.component('s-copyright', Copyright)
